import { Navigate } from "react-router-dom";
import { useClientAuth } from "@/context/ClientAuthContext";

export default function ClientProtectedRoute({ children }) {
    const { status } = useClientAuth();
    if (status === "checking") {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#2a0303]">
                <span className="font-display text-2xl text-[var(--accent-champagne)] soft-pulse">
                    Loading your dashboard…
                </span>
            </div>
        );
    }
    if (status !== "authed") return <Navigate to="/portal" replace />;
    return children;
}
